var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: _vm.formatedCode,
          expression: "formatedCode",
          arg: "copy",
        },
        {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: _vm.onCopy,
          expression: "onCopy",
          arg: "success",
        },
      ],
      staticClass: "code-extract-component",
    },
    [
      _vm.highlight
        ? _c("div", {
            directives: [
              {
                name: "highlightjs",
                rawName: "v-highlightjs",
                value: { language: _vm.highlight, code: _vm.formatedCode },
                expression: "{ language: highlight, code: formatedCode }",
              },
            ],
            staticClass: "code font-monospace mr-2",
          })
        : _c(
            "div",
            {
              staticClass: "code font-monospace mr-2",
              class: { "code-checked": _vm.checked },
            },
            _vm._l(_vm.formatedCodeLines, function (line, index) {
              return _c("div", { key: index }, [
                _vm.prompt
                  ? _c("span", { staticClass: "prompt font-monospace" }, [
                      _vm._v(_vm._s(_vm.prompt) + " "),
                    ])
                  : _vm._e(),
                _vm._v(_vm._s(line)),
              ])
            }),
            0
          ),
      _vm._v(" "),
      _vm.checked !== undefined
        ? _c(
            "div",
            { staticClass: "checked mr-1" },
            [
              _c("KmIcon", {
                style: { opacity: _vm.checked ? 1 : 0 },
                attrs: { color: "success", size: 20, name: "km-icon-check" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("VIcon", { staticClass: "mr-1 icon-copy", attrs: { size: 12 } }, [
        _vm._v("\n    file_copy\n  "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }